<template>
  <div class="modal fade" id="ImtListModal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header ml-3 pl-2">
          <h5 class="modal-title ml-4 float-left font-weight-bold">
            IMT list
          </h5>
          <button type="button" class="close" data-dismiss="modal" id="imt-list-cross-close">
            &times;
          </button>
        </div>
        <div class="mr-4">
          <div class="style-border ml-5 mt-1" />
        </div>
        <div class="modal-body mt-1 pl-5 pb-3">
            <div class="row" >
              <div class="col-lg-6 col-md-6 col-sm-12" v-for="cover in imtListToAdd" 
                :key="cover.coverCode">{{checktotalImtCovers(cover.coverName)}}<span class="imt-covercode" v-show="checkCoverLabelHasImtCode(cover.coverName)"> - {{cover.coverCode}}</span>
              </div>
            </div>
            <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from "@vue/composition-api";
export default {
  name: "ImtListModal",
  props: ['imtListToAdd','getSavedQuoteData'],
  data: function () {
    return {
    };
  },
 
  setup(props, context) {
    let state = reactive({
      });

    // const selectableImtCovers = computed(()=>{
    //   return (props.imtListToAdd.filter(cover => {
    //     return !props.getSavedQuoteData.covers.coverDetails.map(selectedCover => selectedCover.coverCode).includes(cover.coverCode);  
    //   }))
      
    // })
    function checktotalImtCovers(coverName){
      if(coverName.includes('IMT')){
        return (coverName.split('IMT').join('- IMT'));
      }
      else{
        return coverName
      }
    }
    function checkCoverLabelHasImtCode(labelText){
      if(labelText.includes('IMT')){
        return false;
      }
      return true
    }
    return{
      state,
      checkCoverLabelHasImtCode,
      checktotalImtCovers
      // selectableImtCovers
    }
  }
  
};
</script>

<style scoped>
button.close {
  padding-top: 13px;
  text-align: right;
}
.checkbox-position {
  left: 15px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;
}
</style>